import React from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { useState } from 'react'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useEffect } from 'react'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { Link } from 'react-router-dom'

export const Rejected = () => {
  const [data, setData] = useState([])

  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'admin-approval/rejectedRequests')
      .then((res) => {
        setData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.transaction_id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Employee Name',
      selector: (row) => row.payee_name,
      width: '130px',
    },

    {
      name: 'Paid Amount',
      selector: (row) => row.paid_amount,
    },
    {
      name: 'Payment Mode',
      selector: (row) => row.mode_name,
      width: '120px',
    },
    {
      name: 'HR Status',
      selector: (row) => row.status,
    },
    {
      name: 'Final Status',
      selector: (row) => row.final_status,
    },
    {
      name: 'Approved By',
      selector: (row) => row.approved_by,
    },

    {
      name: 'Approved Date',
      selector: (row) => {
        if (row.approved_date === 'Pending') {
          return <p className="mt-3">Pending</p>
        } else {
          return moment(
            new Date(row.approved_date).toISOString().split('T')[0],
          ).format('DD-MM-YYYY')
        }
      },
      width: '130px',
    },
  ]

  //to store current page index in dataTable
  const onPageChange = (pageIndex) => {
    global.pageNumber = pageIndex
  }
  return (
    <div className="rejectRequests row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="rejectRequestsContainer col-md-9 mx-3 mt-2">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb p-3">
            <li className="breadcrumb-item">
              <Link to="/admindashboard" className="link text-primary">
                Home
              </Link>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              Rejected Requests
            </li>
          </ol>
        </nav>
        <DataTable
          title="Rejected Requests"
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          onChangePage={onPageChange}
          paginationDefaultPage={global.pageNumber ? global.pageNumber : 1}
        />
      </div>
    </div>
  )
}
